import { blue, red } from '@ant-design/colors';

export const RESTRICTED_SELECTED_FIELDS = ['timestamp', 'id'];

export const ICON_STYLE = {
	PLUS: { color: blue[5] },
	CLOSE: { color: red[5] },
};
